(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vh-size-picker"] && !Shopify.designMode) return;
  try {
    class VhSizePicker extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section') || document;
      this.timer = null;
      this.snaps = 0;
      if (this.dataset.mode === 'custom') this.#initCustom();
      else this.#initList();
      this.#initConsent();
      document.addEventListener('vh:variant-synced', (event) => this.#synced(event.detail?.html));
    }

    /* Dwell'in seçicisindeki açılır liste ya da radyo; her seferinde taze sorgulanır (morph) */
    #control(name, root = this.section) {
      const picker = root.querySelector('variant-picker');
      if (!picker) return null;
      const select = picker.querySelector(`select[name="options[${CSS.escape(name)}]"]`);
      if (select) return { select };
      const radios = [...picker.querySelectorAll(`input[data-option-name="${CSS.escape(name)}"]`)];
      return radios.length ? { radios } : null;
    }

    #current(name) {
      const c = this.#control(name);
      if (!c) return null;
      if (c.select) return c.select.value;
      return c.radios.find((r) => r.checked)?.value ?? null;
    }

    /* { optionName: value } eşlemesini uygular, en sonda tek bir change olayı yollar */
    #apply(map) {
      let last = null;
      for (const [name, value] of Object.entries(map)) {
        const c = this.#control(name);
        if (!c) continue;
        if (c.select) {
          const opt = [...c.select.options].find((o) => o.value === value);
          if (!opt) continue;
          [...c.select.options].forEach((o) => o.removeAttribute('selected'));
          opt.setAttribute('selected', 'selected');
          c.select.value = value;
          last = c.select;
        } else {
          const radio = c.radios.find((r) => r.value === value);
          if (!radio) continue;
          radio.checked = true;
          last = radio;
        }
      }
      if (last) this.#hold();
      last?.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* Varyant güncellenene kadar sepete ekleme bekler; yanıt gelmezse kilit 4 sn sonra açılır */
    #hold() {
      this.pending = true;
      clearTimeout(this.pendingTimer);
      this.pendingTimer = setTimeout(() => (this.pending = false), 4000);
    }

    #initList() {
      this.name = this.dataset.sName;
      this.querySelector('[data-list-select]')?.addEventListener('change', (event) => {
        this.#apply({ [this.name]: event.target.value });
      });
    }

    #initCustom() {
      this.kod = this.hasAttribute('data-kod'); /* tek "Ölçü" seçeneği, ızgara varyantları kodlu */
      this.sName = this.dataset.sName;
      this.wName = this.dataset.wName;
      this.lName = this.dataset.lName;
      this.wValues = JSON.parse(this.dataset.wValues || '[]');
      this.lValues = JSON.parse(this.dataset.lValues || '[]');
      this.min = parseInt(this.dataset.min, 10) || 0;
      try {
        this.ozel = JSON.parse(this.dataset.ozel || 'null');
      } catch {
        this.ozel = null;
      }
      this.step = { w: parseInt(this.dataset.stepW, 10) || 0, l: parseInt(this.dataset.stepL, 10) || 0 };
      this.inputs = { w: this.querySelector('[data-input="w"]'), l: this.querySelector('[data-input="l"]') };
      this.roundEl = this.querySelector('[data-round]');
      this.orderEl = this.querySelector('[data-order-size]');
      this.preset = this.querySelector('[data-preset-select]');
      this.typed = null; /* müşterinin yazdığı ölçü, fiyatı alınan ölçüden farklıysa { w, l } */
      this.resultHTML = this.querySelector('.vh-size__result strong')?.innerHTML ?? '';
      this.basis = null; /* fiyatı alınan (seçilen varyantın) ölçüsü { w, l } */

      this.shapeName = this.dataset.shapeName;
      this.querySelectorAll('.vh-size__shape').forEach((btn) =>
        btn.addEventListener('click', () => {
          this.querySelectorAll('.vh-size__shape').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
          this.#roundMode();
          this.#price();
        })
      );
      this.#roundMode();

      this.preset?.addEventListener('change', () => {
        if (this.preset.value === 'custom') {
          this.inputs.w.focus();
          return;
        }
        const [w, l] = this.preset.value.split('x');
        this.inputs.w.value = w;
        this.inputs.l.value = l;
        this.#price();
      });

      this.querySelectorAll('[data-step]').forEach((btn) =>
        btn.addEventListener('click', () => {
          const key = btn.dataset.for;
          const grid = this.#adimlar(key);
          const v = parseInt(this.inputs[key].value, 10) || grid[0];
          const next =
            Number(btn.dataset.step) > 0
              ? grid.find((n) => n > v) ?? grid[grid.length - 1]
              : [...grid].reverse().find((n) => n < v) ?? grid[0];
          this.inputs[key].value = next;
          this.#price(350);
        })
      );

      Object.values(this.inputs).forEach((input) => input?.addEventListener('change', () => this.#price()));
      this.#guardSubmit();
      this.#kodSecili();
    }

    /*
      Sayfa kodlu bir varyantla açıldıysa (adres çubuğundaki ?variant=, geri tuşu) müşterinin yazdığı ölçü bilinmez:
      kodun ölçüsü girişlere ve siparişe "Sipariş ölçüsü" olarak yazılır, kod hiçbir yerde görünmez.
    */
    #kodSecili() {
      if (!this.kod || this.#stdSecili()) return;
      const cur = this.#currentSize();
      if (!cur) return;
      this.inputs.w.value = cur.w;
      this.inputs.l.value = cur.l;
      this.basis = cur;
      this.typed = { ...cur };
      this.#markPreset(cur.w, cur.l);
      this.#orderSize();
    }

    /* Kodlu üründe seçili varyant hazır ölçülerden biri mi */
    #stdSecili() {
      return Object.values(this.ozel?.std || {}).includes(this.#current(this.sName));
    }

    /* Seçili varyantın ölçüsü { w, l }; kodlu üründe ad → ölçü eşlemesinden (vamos.ozel_ayar std / kod) */
    #currentSize() {
      if (!this.kod) {
        const w = parseInt(this.#current(this.wName), 10);
        const l = parseInt(this.#current(this.lName), 10);
        return w && l ? { w, l } : null;
      }
      const ad = this.#current(this.sName);
      if (!ad) return null;
      const { std = {}, kod = {}, kod_ad: kodAd = '' } = this.ozel || {};
      const key =
        Object.keys(std).find((k) => std[k] === ad) ??
        Object.keys(kod).find((k) => this.#fill(kodAd, { n: kod[k] }) === ad);
      if (!key) return null;
      if (key.startsWith('o')) {
        const d = parseInt(key.slice(1), 10);
        return { w: d, l: d };
      }
      const [w, l] = key.split('x').map(Number);
      return { w, l };
    }

    /* Seçenek değerleri sayı olarak, küçükten büyüğe (Shopify'daki sıra karışık olabilir) */
    #nums(key) {
      const list = key === 'w' ? this.wValues : this.lValues;
      return list.map((v) => parseInt(v, 10)).sort((a, b) => a - b);
    }

    /* Fiyat ızgarası: en küçük ölçüden başlayıp adım adım (80, 100, 120 …) + üründeki en büyük ölçü */
    #grid(key) {
      const all = this.#nums(key);
      const step = this.step[key];
      if (!step) return all.filter((n) => n >= this.min);
      const grid = all.filter((n) => n >= this.min && (n - this.min) % step === 0);
      const max = all[all.length - 1];
      if (grid.length && grid[grid.length - 1] !== max) grid.push(max);
      return grid.length ? grid : all;
    }

    get #shape() {
      return this.querySelector('.vh-size__shape[aria-pressed="true"]')?.dataset.shape ?? null;
    }

    #fill(template, values) {
      return Object.entries(values).reduce((t, [k, v]) => t.replaceAll(`[${k}]`, v), template || '');
    }

    #note(text) {
      if (!this.roundEl) return;
      this.roundEl.textContent = text;
      this.roundEl.hidden = !text;
    }

    #fmt(size) {
      return this.hasAttribute('data-round') ? `Ø ${size.w}` : `${size.w} × ${size.l}`;
    }

    /* Yuvarlakta tek ölçü (çap): boy kutusu ve hazır ölçüler gizlenir, boy = en */
    #roundMode() {
      if (!this.shapeName) return;
      const round = this.#shape === this.dataset.roundShape;
      this.toggleAttribute('data-round', round);
      const wLabel = this.querySelector('[data-stepper="w"] [data-label]');
      if (wLabel) wLabel.textContent = round ? this.dataset.diameterLabel : this.dataset.widthLabel;
      this.querySelector('[data-presets]')?.toggleAttribute('hidden', round);
    }

    /* En: rulo enleri (vamos.ozel_ayar); yoksa (mock) seçenek değerlerinden adım ızgarası. Yuvarlakta çaplar */
    #enler(round = this.hasAttribute('data-round')) {
      if (this.ozel) {
        const list = round && this.ozel.yuvarlak?.length ? this.ozel.yuvarlak : this.ozel.enler || [];
        return list.map(Number).filter(Boolean).sort((a, b) => a - b);
      }
      return this.#grid('w');
    }

    /* Boy: kademeli (4 m'ye kadar 10 cm, sonra 20 cm; vamos.ozel_ayar ya da Boy seçeneği); mock'ta adım ızgarası */
    #boylar() {
      if (this.ozel?.boylar) return this.ozel.boylar.map(Number).sort((a, b) => a - b);
      return this.ozel ? this.#nums('l') : this.#grid('l');
    }

    /* Bir enin üretilebildiği en uzun boy (yolluklarda 10 m, geniş halılarda 6 m) */
    #boyMax(rulo) {
      return Number(this.ozel?.boy_max?.[rulo]) || this.#boylar().at(-1);
    }

    /* +/− düğmelerinin gezdiği değerler */
    #adimlar(key) {
      return key === 'w' ? this.#enler() : this.#boylar();
    }

    /*
      Yazılan ölçüden fiyatı alınacak varyantı bulur. Hazır ölçü birebir (iki yönde de) yazıldıysa o; değilse kısa
      kenar en sayılır ve bir üst rulo enine, uzun kenar bir üst boya yuvarlanır (halı döndürülmez: desen rulo
      boyunca uzanır). En çok genişse en geniş ruloya, boy o enin en uzun boyundan uzunsa en uzun boya çekilir.
    */
    #price(delay = 0, depth = 0, carry = []) {
      clearTimeout(this.timer);
      this.snaps = 0;
      const round = this.hasAttribute('data-round');
      const notes = [...carry];
      const enler = this.#enler(round);
      const boylar = round ? enler : this.#boylar();
      if (!enler.length || !boylar.length) return;
      const alt = Math.min(this.min || enler[0], enler[0]);
      const read = (key) => {
        let n = parseInt(this.inputs[key].value, 10);
        if (Number.isNaN(n)) n = this.#currentSize()?.[key] || alt;
        if (n < alt) {
          n = alt;
          if (!notes.length) notes.push(this.#fill(this.dataset.minNote, { min: alt }));
        }
        this.inputs[key].value = n;
        return n;
      };
      const w = read('w');
      const l = round ? w : read('l');
      if (round) this.inputs.l.value = w;

      let basis = null;
      const hazir = round
        ? null
        : [...(this.preset?.options || [])]
            .map((o) => o.value.split('x').map(Number))
            .find(([a, b]) => (a === w && b === l) || (a === l && b === w));
      if (hazir) {
        basis = { w: hazir[0], l: hazir[1] };
      } else {
        const kisa = Math.min(w, l);
        const uzun = Math.max(w, l);
        const yonler = (round ? [[w, w, 'w']] : [[kisa, uzun, w <= l ? 'l' : 'w']]).map(([a, b, bKey]) => {
          const rulo = enler.find((x) => x >= a);
          if (!rulo) return null;
          const maxB = round ? rulo : this.#boyMax(rulo);
          const boy = round ? rulo : boylar.find((x) => x >= b && x <= maxB);
          return { rulo, boy, maxB, bKey };
        });
        const uygun = yonler
          .filter((y) => y?.boy)
          .sort((x, y) => x.rulo * x.boy - y.rulo * y.boy || (x.rulo > x.boy) - (y.rulo > y.boy));
        if (uygun.length) {
          basis = { w: uygun[0].rulo, l: uygun[0].boy };
        } else if (depth < 2) {
          const y = yonler.find(Boolean);
          if (y) {
            /* Boy bu ende üretilenden uzun: en uzun boya çekilir */
            const maxL = [...boylar].reverse().find((x) => x <= y.maxB);
            this.inputs[y.bKey].value = maxL;
            return this.#price(delay, depth + 1, [this.#fill(this.dataset.longNote, { max: maxL })]);
          }
          /* En çok geniş: kısa kenar en geniş ruloya çekilir */
          const maxW = enler.at(-1);
          this.inputs[w <= l ? 'w' : 'l'].value = maxW; /* kısa kenar */
          if (round) this.inputs.l.value = maxW;
          return this.#price(delay, depth + 1, [this.#fill(this.dataset.maxNote, { max: round ? `Ø ${maxW}` : maxW })]);
        } else {
          return;
        }
      }

      const ayni = (basis.w === w && basis.l === l) || (basis.w === l && basis.l === w);
      let map = { [this.wName]: `${basis.w} cm`, [this.lName]: `${basis.l} cm` };
      if (this.kod) {
        /* Hazır ölçü birebir yazıldıysa kendi varyantı; değilse o ölçünün kodu (yazılan ölçü siparişe gider) */
        const key = round ? `o${basis.w}` : `${basis.w}x${basis.l}`;
        const std = ayni ? this.ozel.std?.[key] : null;
        const n = this.ozel.kod?.[key];
        if (!std && !n) return;
        map = { [this.sName]: std ?? this.#fill(this.ozel.kod_ad, { n }) };
        this.typed = std ? null : { w, l };
      } else {
        this.typed = ayni ? null : { w, l };
      }
      this.basis = basis;
      if (this.typed && this.dataset.priceNote) {
        notes.push(this.#fill(this.dataset.priceNote, { girilen: this.#fmt(this.typed), secilen: this.#fmt(basis) }));
      }
      this.#note(notes.join(' '));
      this.#markPreset(w, l);
      this.#orderSize();

      if (this.shapeName && this.#shape) map[this.shapeName] = this.#shape;
      const same = Object.entries(map).every(([name, value]) => this.#current(name) === value);
      if (same) return;
      this.#hold();
      this.timer = setTimeout(() => this.#apply(map), delay);
    }

    /* Yazılan ölçü: siparişe satır bilgisi, sonuç satırında müşterinin ölçüsü */
    #orderSize() {
      const typed = this.typed ? `${this.#fmt(this.typed)} cm` : '';
      if (this.orderEl) {
        this.orderEl.value = typed;
        this.orderEl.disabled = !typed;
      }
      this.toggleAttribute('data-typed', Boolean(typed));
      /* Yapışkan bar: Dwell varyant değişince sunucudan yeniler (morph); yazılan ölçü onun üstüne yazılır */
      const sticky = this.section.querySelector('.sticky-add-to-cart__variant');
      if (sticky && typed) {
        if (!sticky.hasAttribute('data-typed')) this.stickyText = sticky.textContent;
        sticky.textContent = typed;
        sticky.setAttribute('data-typed', '');
      } else if (sticky?.hasAttribute('data-typed')) {
        sticky.textContent = this.stickyText ?? '';
        sticky.removeAttribute('data-typed');
      }
      const strong = this.querySelector('.vh-size__result strong');
      if (!strong) return;
      if (typed) {
        strong.textContent = typed;
        strong.setAttribute('data-typed', '');
      } else if (strong.hasAttribute('data-typed')) {
        strong.innerHTML = this.resultHTML;
        strong.removeAttribute('data-typed');
      }
    }

    #markPreset(w, l) {
      if (!this.preset) return;
      const a = parseInt(w, 10);
      const b = parseInt(l, 10);
      const hit = [...this.preset.options].find((o) => o.value === `${a}x${b}` || o.value === `${b}x${a}`);
      this.preset.value = hit ? hit.value : 'custom';
    }

    /* Varyant güncellenirken sepete ekleme bekler, güncelleme bitince kendiliğinden devam eder */
    #guardSubmit() {
      const hold = (event) => {
        if (!this.pending) return;
        const t = event.target;
        if (!(t instanceof Element)) return;
        const button = t.closest?.('.sticky-add-to-cart__button, product-form-component [type="submit"]');
        if (!button || !this.section.contains(button)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.resubmit = button;
      };
      document.addEventListener('click', hold, true);
    }

    /* Varyant değişti: girişleri eşitle; seçilen kombinasyon üretilmiyorsa bir üst üretilen ölçüye geç */
    #synced(html) {
      this.pending = false;
      clearTimeout(this.pendingTimer);
      const fresh = html?.querySelector?.('vh-size-picker .vh-size__result strong');
      if (fresh) {
        this.resultHTML = fresh.innerHTML;
        this.querySelector('.vh-size__result strong')?.removeAttribute('data-typed');
        this.section.querySelector('.sticky-add-to-cart__variant')?.removeAttribute('data-typed');
      }
      if (this.dataset.mode !== 'custom') {
        const v = this.#current(this.name);
        const select = this.querySelector('[data-list-select]');
        if (v && select) select.value = v;
        return;
      }
      if (this.kod) {
        /* Kodlu üründe her ölçünün varyantı var: üst ölçüye kaydırma gerekmez */
        const cur = this.#currentSize();
        if (!(this.basis && cur && this.basis.w === cur.w && this.basis.l === cur.l)) {
          this.typed = null;
          this.basis = null;
        }
        if (cur && !this.typed) {
          this.inputs.w.value = cur.w;
          this.inputs.l.value = cur.l;
          this.#markPreset(cur.w, cur.l);
        }
        if (!this.typed) this.#kodSecili();
        this.#orderSize();
        const button = this.resubmit;
        this.resubmit = null;
        if (button?.isConnected) requestAnimationFrame(() => button.click());
        return;
      }
      const w = this.#current(this.wName);
      const l = this.#current(this.lName);
      const vw = parseInt(w, 10);
      const vl = parseInt(l, 10);
      const expected = this.basis && this.basis.w === vw && this.basis.l === vl;
      if (!expected) {
        this.typed = null;
        this.basis = null;
      }
      if (w && l && !this.typed) {
        this.inputs.w.value = vw;
        this.inputs.l.value = vl;
        this.#markPreset(w, l);
      }
      this.#orderSize();
      if (!html?.querySelector) return;
      const data = html.querySelector('variant-picker script[type="application/json"]');
      if (!data || data.textContent.trim() !== 'null') {
        this.snaps = 0;
        const button = this.resubmit;
        this.resubmit = null;
        if (button?.isConnected) requestAnimationFrame(() => button.click());
        return;
      }
      if (this.snaps++ > 1) return;
      /* Yeni HTML'deki seçeneklerde data-variant-id doluysa o değer diğer seçimlerle birlikte üretiliyor */
      const above = (name, target) => {
        const c = this.#control(name, html);
        if (!c?.select) return null;
        const t = parseInt(target, 10);
        const ok = [...c.select.options]
          .filter((o) => o.dataset.variantId)
          .map((o) => o.value)
          .sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
        return ok.find((v) => parseInt(v, 10) >= t) ?? ok[ok.length - 1] ?? null;
      };
      const round = this.hasAttribute('data-round');
      const from = this.typed ? this.#fmt(this.typed) : this.#fmt({ w: vw, l: vl });
      const map = {};
      const nl = round ? null : above(this.lName, l);
      if (nl) {
        map[this.lName] = nl;
      } else {
        const nw = above(this.wName, w);
        if (!nw) return;
        map[this.wName] = nw;
        if (round) map[this.lName] = nw;
      }
      const to = this.#fmt({ w: parseInt(map[this.wName] || w, 10), l: parseInt(map[this.lName] || l, 10) });
      this.typed = null;
      this.basis = null;
      this.#orderSize();
      this.#note(this.#fill(this.dataset.snapNote, { girilen: from, secilen: to }));
      if (this.shapeName && this.#shape) map[this.shapeName] = this.#shape;
      this.#apply(map);
    }

    /* Özel ölçüde onay kutusu işaretlenmeden sepete ekleme engellenir */
    #initConsent() {
      const box = this.querySelector('[data-consent]');
      if (!box) return;
      const msg = this.querySelector('[data-consent-msg]');
      box.addEventListener('change', () => {
        if (box.checked) msg.hidden = true;
      });
      const block = (event) => {
        if (box.checked) return;
        const t = event.target;
        if (!(t instanceof Element)) return;
        const isForm = t.matches?.(`form#${CSS.escape(box.getAttribute('form'))}`);
        const isButton = t.closest?.('.sticky-add-to-cart__button, product-form-component [type="submit"]');
        if (!isForm && !(isButton && this.section.contains(t))) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        msg.textContent = this.dataset.consentError;
        msg.hidden = false;
        box.closest('.vh-size__legal').scrollIntoView({ behavior: 'smooth', block: 'center' });
        box.focus({ preventScroll: true });
      };
      document.addEventListener('click', block, true);
      document.addEventListener('submit', block, true);
    }
  }
  if (!customElements.get('vh-size-picker')) customElements.define('vh-size-picker', VhSizePicker);
  } catch(e) { console.error(e); }
})();

})();
